var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavourite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.03 4c-.98 0-1.92.28-2.7.82-.4.28-.76.59-1.08.92l-.18.2-.16.2-.1.13-.1-.14a7.05 7.05 0 00-1.41-1.3 4.5 4.5 0 00-2.63-.81c-3.83-.06-6 3.7-3.78 8.4C5.78 16.43 9.83 20 11.81 20c1.99 0 6.04-3.58 7.93-7.6 2.2-4.65.1-8.37-3.7-8.4zm-.22 1.97h.21c2.32.01 3.55 2.2 1.94 5.6a15.24 15.24 0 01-3.65 4.85c-1.1.97-2.22 1.62-2.5 1.62-.27 0-1.38-.64-2.49-1.62a15.14 15.14 0 01-3.65-4.84c-1.62-3.43-.35-5.63 2-5.6.56 0 1.07.16 1.5.47a4.68 4.68 0 011.52 1.73l.09.19.06.14.02.09c.25.94 1.54.98 1.87.11l.04-.12a4.37 4.37 0 011.67-2.15c.4-.27.87-.43 1.37-.47z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.79e45b53.svg";
export { ForwardRef as ReactComponent };